<template>
  <p class="ellipsis" ref="p" @click="toggleEllipsis">
    {{ displayValue }}
  </p>
</template>
<script>
export default {
  props: {
    expandables: {
      type: Boolean,
      default: true
    },
    assumePixel: {
      type: Number,
      default: 4
    },
    content: {
      type: String,
      required: true,
    },
    isCurrentUser: {
      type: Boolean
    },
    byWord: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      displayValue: this.content,
      ellipsis: true,
    }
  },
  watch: {
    ellipsis: function() {
       this.validateEllipsis();
    }
  },
  mounted() {
    this.validateEllipsis();
  },
  methods: {
    validateEllipsis() {
      if (this.byWord && this.ellipsis) {
        let assumePixels = this.assumePixel;
        let maxChars = this.$refs.p.clientWidth / assumePixels;
        if (maxChars < this.content.length) {
          var str = this.content.substring(0, (maxChars))
          if (str.length>0) {
            var regex = /[A-Za-z0-9]/g;
            var matches = str[str.length - 1].match(regex)
            while(matches && matches.length > 0) {
              str = str.slice(0, -1)
              matches = str[str.length - 1].match(regex)
            }
            this.displayValue = str + '...'
            return
          }
        }
      }

      if (this.ellipsis) {
        let assumePixels = this.assumePixel;
        let maxChars = this.$refs.p.clientWidth / assumePixels;
        if (maxChars < this.content.length) {
          this.displayValue = (this.content.substring(0, (maxChars))) + '...'
          return
        }
      }
      this.displayValue = this.content;

    },
    setEllipsis(v) {
      if(!this.expandables) return;

      this.ellipsis = !this.ellipsis
      if( this.ellipsis ) {
        this.$emit('collapsed')
      } else {
        this.$emit('expanded')
      }
    },
    toggleEllipsis(v, isToggle) {
      if(!this.expandables) return;

      if ( !this.ellipsis && this.isCurrentUser) {
        this.$parent.$parent.onClick();
        return false
      }

      this.ellipsis = !this.ellipsis
      if( this.ellipsis ) {
        this.$emit('collapsed')
      } else {
        this.$emit('expanded')
      }
    }
  }

}
</script>
<style>
.ellipsis {
  position: relative;
  padding: 0 !important;
}

</style>
